<script lang="ts">
  // Undo-send countdown (spec §15/§16): `sendingIn {n}` ticks down while `store.pendingSend`
  // is set; the button cancels the queued send and reopens the draft.
  import { t } from '$lib/i18n';
  import { store } from '$lib/store';
</script>

{#if store.pendingSend}
  <div class="toast sendtoast" role="status">
    <span>{t('sendingIn', { n: store.pendingSend.left })}</span>
    <button type="button" class="undo-btn" onclick={() => void store.cancelSend()}>{t('undoSend')}</button>
  </div>
{/if}

<style>
  /* @css shell/SendUndoToast start */
  .sendtoast {
    display: flex;
    align-items: center;
    gap: var(--space-4)
  }

  .sendtoast .undo-btn {
    border: 1px solid currentColor;
    border-radius: var(--radius-pill);
    background: none;
    color: inherit;
    padding: var(--space-1) var(--space-3);
    font: inherit;
    cursor: pointer
  }

  .toast {
    position: fixed;
    inset-inline: 0;
    bottom: calc(var(--space-5) + env(safe-area-inset-bottom));
    margin-inline: auto;
    width: fit-content;
    max-width: calc(100% - var(--space-8));
    display: flex;
    align-items: center;
    gap: var(--space-3);
    background: var(--neutral-900);
    color: var(--neutral-0);
    padding: var(--space-3) var(--space-5);
    border-radius: var(--radius-pill);
    font-size: var(--text-sm);
    line-height: var(--leading-body);
    box-shadow: var(--shadow-lg);
    z-index: var(--z-toast);
    animation: svelte-1n46o8q-toast-in .2s var(--ease-out)
  }

  :global(html.tik-dark) .toast {
    background: var(--neutral-0);
    color: var(--neutral-900)
  }

  @media (max-width:900px) {
  .toast {
      bottom: calc(var(--tabbar-h) + var(--space-8) + env(safe-area-inset-bottom))
    }
  }

  @keyframes svelte-1n46o8q-toast-in {
    0% {
      opacity: 0;
      transform: translateY(8px)
    }
  }
  /* @css shell/SendUndoToast end */
</style>
